export const TOKEN_NAME = 'token';
export const REFRESH_TOKEN_NAME = 'refresh';
export const LANGUAGE_NAME = 'language_code';
